import React from 'react'
import NewsCreateForm from '../../forms/NewsCreateForm'

function NewsAdminCreate() {
  return (
    <div>
        <NewsCreateForm/>
    </div>
  )
}

export default NewsAdminCreate